import startCase from 'lodash-es/startCase'
import {
  EntityRole,
  EntityRoleSelectType,
} from '@/legacy/types/entities/entities'

export const humanizeRole = (role: EntityRole | string | null) => {
  // NOTE: if names are changed here, they should also be changed in the
  // infrastructure repo (`terraform/modules/auth0/roles.tf`)
  // and thymeboxserver (`entities/client/enums/entity_roles.py`) so they
  // are the same everywhere
  switch (role) {
    case EntityRole.CLINICAL__CARE_PARTNER: {
      return 'Care Partner'
    }
    case EntityRole.CLINICAL__ADMIN_ASSISTANT: {
      return 'Admin Assistant'
    }
    case EntityRole.CLINICAL: {
      return 'Care Team (general)'
    }
    case EntityRole.CLINICAL__NURSE: {
      return 'Nurse'
    }
    case EntityRole.CLINICAL__ENROLLMENT_SPECIALIST: {
      return 'Enrollment Specialist'
    }
    case EntityRole.CLINICAL__ENROLLMENT_SPECIALIST_LEAD: {
      return 'Enrollment Specialist Lead'
    }
    case EntityRole.ENROLLMENT_OPS_COORDINATOR: {
      return 'Enrollment Ops Coordinator'
    }
    case EntityRole.CLINICAL__CARE_POD_LEAD: {
      return 'Care Pod Lead'
    }
    case EntityRole.CLINICAL__MEDICAL_DIRECTOR: {
      return 'Medical Director'
    }
    case EntityRole.CLINICAL__TIERING_NP: {
      return 'Tiering NP'
    }
    case EntityRole.CLINICAL__LIAISON: {
      return 'Clinical Liaison'
    }
    case EntityRole.CLINICAL__THYME_CARE_MEDICAL_AA: {
      return 'Thyme Care Medical AA'
    }
    case EntityRole.CLINICAL__SOCIAL_WORKER: {
      return 'Social Worker'
    }
    case EntityRole.CLINICAL__NURSE_PRACTITIONER: {
      return 'Nurse Practitioner'
    }
    case EntityRole.STAFF: {
      return 'Staff'
    }
    case EntityRole.SYSTEM: {
      return 'System'
    }
    case EntityRole.AUTOMATION: {
      return 'Automation'
    }
    case EntityRole.PATIENT: {
      return 'Patient'
    }
    case EntityRole.PROVIDER: {
      return 'External Provider'
    }
    case EntityRole.CONTACT: {
      return 'Contact'
    }
    case EntityRole.TECH_TEAM: {
      return 'Tech Team'
    }
    case EntityRole.ADMIN: {
      return 'Explicit Admin'
    }
    case EntityRole.CARE_TEAM_LEADERSHIP: {
      return 'Care Team Leadership'
    }
    case EntityRole.SPECIALIZATION__MEDICAL_DIRECTOR_PALLIATIVE_CARE: {
      return 'Medical Director - Palliative Care'
    }
    case EntityRole.SPECIALIZATION__MEDICAL_DIRECTOR_ONCOLOGY: {
      return 'Medical Director - Oncology'
    }
    case EntityRole.SPECIALIZATION__TRANSITIONS_OF_CARE_CP: {
      return 'Transitions of Care CP'
    }
    case EntityRole.SPECIALIZATION__TRANSITIONS_OF_CARE_RN: {
      return 'Transitions of Care RN'
    }
    case EntityRole.SPECIALIZATION__TRANSITIONS_OF_CARE_AA: {
      return 'Transitions of Care AA'
    }
    case EntityRole.QUALITY_TRAINING_ENABLEMENT: {
      return 'Quality, Training, and Enablement (QTE)'
    }
    case EntityRole.CONTENT_MANAGER: {
      return 'Content Manager'
    }
    case EntityRole.SPECIALIZATION__ONBOARDING_RN: {
      return 'Onboarding RN'
    }
    case EntityRole.SPECIALIZATION__ONBOARDING_CP: {
      return 'Onboarding CP'
    }
    case EntityRole.SPECIALIZATION__FLOAT_RN: {
      return 'Float RN'
    }
    case EntityRole.SPECIALIZATION__FLOAT_CP: {
      return 'Float CP'
    }
    case EntityRole.SPECIALIZATION__MEDICAL_RECORDS_AA: {
      return 'Medical Records AA'
    }
    case EntityRole.SPECIALIZATION__MAILER_AA: {
      return 'Mailer AA'
    }
    case EntityRole.SPECIALIZATION__SERIOUS_ILLNESS_CONVERSATION_RN: {
      return 'Serious Illness Conversation RN'
    }
    case EntityRole.SPECIALIZATION__SERIOUS_ILLNESS_CONVERSATION_CP: {
      return 'Serious Illness Conversation CP'
    }
    case EntityRole.SPECIALIZATION__TRIAGE_RN: {
      return 'Triage RN'
    }
    case EntityRole.SPECIALIZATION__TRIAGE_NP: {
      return 'Triage Nurse Practitioner'
    }
    case EntityRole.SPECIALIZATION__TRIAGE_SW: {
      return 'Triage Social Worker'
    }
    case EntityRole.SPECIALIZATION__TRIAGE_CP: {
      return 'Triage Care Partner'
    }
    case EntityRole.SPECIALIZATION__BEHAVIORAL_HEALTH_LEAD: {
      return 'Behavioral Health Lead'
    }
    case EntityRole.SPECIALIZATION__BEHAVIORAL_HEALTH_CP: {
      return 'Behavioral Health Care Partner'
    }
    case EntityRole.SPECIALIZATION__BEHAVIORAL_HEALTH_RN: {
      return 'Behavioral Health RN'
    }
    case EntityRole.SPECIALIZATION__BEHAVIORAL_HEALTH_SW: {
      return 'Behavioral Health Social Worker'
    }
    case EntityRole.SPECIALIZATION__COMPLEX_TEAM_LEAD: {
      return 'Complex Team Lead'
    }
    case EntityRole.SPECIALIZATION__ADVANCED_SOCIAL_NEEDS_RN: {
      return 'Advanced Social Needs RN'
    }
    case EntityRole.SPECIALIZATION__ADVANCED_SOCIAL_NEEDS_CP: {
      return 'Advanced Social Needs Care Partner'
    }
    case EntityRole.SPECIALIZATION__ADVANCED_SOCIAL_NEEDS_SW: {
      return 'Advanced Social Needs Social Worker'
    }
    case EntityRole.SPECIALIZATION__SITE_OF_SERVICE_SHIFT_RN: {
      return 'Site of Service RN'
    }
    case EntityRole.SPECIALIZATION__SITE_OF_SERVICE_SHIFT_CP: {
      return 'Site of Service CP'
    }
    case EntityRole.SPECIALIZATION__PALLIATIVE_CARE_NP: {
      return 'Palliative Care NP'
    }
    case EntityRole.SPECIALIZATION__TCM_COB_RN: {
      return 'TCM COB RN'
    }
    case EntityRole.TCOP_PARTNERSHIP_OPS: {
      return 'TCOP Partnership Ops'
    }
    case EntityRole.TCOP_NP_LIAISON: {
      return 'TCOP NP Liaison'
    }
    case EntityRole.SPECIALIZATION__HWV_NP: {
      return 'HWV Nurse Practitioner'
    }
    case EntityRole.SPECIALIZATION__COMMUNITY_CP: {
      return 'Community Care Partner'
    }
    case EntityRole.SPECIALIZATION__PRACTICE_COORDINATOR_TEAM_LEAD: {
      return 'Practice Coordinator Team Lead'
    }
    case EntityRole.NURSE_PRACTITIONER_TEAM_LEAD: {
      return 'Nurse Practitioner Team Lead'
    }
    case EntityRole.PRACTICE_COORDINATOR: {
      return 'Practice Coordinator'
    }
    case EntityRole.PRACTICE_ADMINISTRATOR: {
      return 'Practice Administrator'
    }
    case EntityRole.ON_DEMAND_MEMBER_SUPPORT: {
      return 'Member Support'
    }
    case null: {
      return '<Unknown>'
    }
    default: {
      return startCase(role)
    }
  }
}
const sortedRoles = Object.values(EntityRole).sort((a, b) =>
  humanizeRole(a).localeCompare(humanizeRole(b))
)

export const staffRoles = sortedRoles.filter(
  (r) =>
    ![EntityRole.CONTACT, EntityRole.PATIENT, EntityRole.PROVIDER].includes(r)
)

export const adminSubtaskResponsibleRoles = sortedRoles.filter(
  (r) => r !== EntityRole.CONTACT
)

export const coreCareTeamRoles = staffRoles.filter(
  // same as subtask owner roles, but only the core care team roles
  (r) => r.startsWith('clinical__')
)

// Filter to only the sub-care team roles.
// Any other roles can be assigned to by the system (and displayed),
// but not manually assigned to
export const subtaskOwnerRoles = coreCareTeamRoles

const _getRoleOptions = (
  selectType: EntityRoleSelectType,
  roles: EntityRole[]
) => {
  if (selectType === EntityRoleSelectType.Radio) {
    return roles.map((r) => [humanizeRole(r), r])
  }
  if (selectType === EntityRoleSelectType.PVDropdown) {
    return roles.map((r) => ({ label: humanizeRole(r), value: r }))
  }
  return roles.map((r) => [r, humanizeRole(r)])
}

export const staffRoleOptions = (selectType: EntityRoleSelectType) => {
  return _getRoleOptions(selectType, staffRoles)
}

export const subtaskOwnerRoleOptions = (selectType: EntityRoleSelectType) => {
  return _getRoleOptions(selectType, subtaskOwnerRoles)
}

export const coreCareTeamRoleOptions = (selectType: EntityRoleSelectType) => {
  return _getRoleOptions(selectType, coreCareTeamRoles)
}

export const adminSubtaskResponsibleRoleOptions = (
  selectType: EntityRoleSelectType
) => {
  return _getRoleOptions(selectType, adminSubtaskResponsibleRoles)
}

export const additionalAssignableRoles = [
  {
    value: EntityRole.SPECIALIZATION__SITE_OF_SERVICE_SHIFT_CP,
    label: 'Site of Service CP',
  },
  {
    value: EntityRole.SPECIALIZATION__TRANSITIONS_OF_CARE_RN,
    label: 'Transitions of Care RN',
  },
  { value: EntityRole.SPECIALIZATION__ONBOARDING_RN, label: 'Onboarding RN' },
  { value: EntityRole.SPECIALIZATION__ONBOARDING_CP, label: 'Onboarding CP' },
  { value: EntityRole.SPECIALIZATION__FLOAT_RN, label: 'Float RN' },
  { value: EntityRole.SPECIALIZATION__FLOAT_CP, label: 'Float CP' },
  {
    value: EntityRole.SPECIALIZATION__MEDICAL_RECORDS_AA,
    label: 'Medical Records AA',
  },
  { value: EntityRole.TCOP_PARTNERSHIP_OPS, label: 'TCOP Partnership Ops' },
  { value: EntityRole.TCOP_NP_LIAISON, label: 'TCOP NP Liaison' },
  {
    value: EntityRole.SPECIALIZATION__SERIOUS_ILLNESS_CONVERSATION_RN,
    label: 'Serious Illness Conversation RN',
  },
  {
    value: EntityRole.SPECIALIZATION__SERIOUS_ILLNESS_CONVERSATION_CP,
    label: 'Serious Illness Conversation CP',
  },
  {
    value: EntityRole.SPECIALIZATION__TRIAGE_RN,
    label: 'Triage RN',
  },
  {
    value: EntityRole.SPECIALIZATION__BEHAVIORAL_HEALTH_LEAD,
    label: 'Behavioral Health Lead',
  },
  {
    value: EntityRole.SPECIALIZATION__COMPLEX_TEAM_LEAD,
    label: 'Complex Team Lead',
  },
  {
    value: EntityRole.SPECIALIZATION__BEHAVIORAL_HEALTH_CP,
    label: 'Behavioral Health CP',
  },
  {
    value: EntityRole.SPECIALIZATION__BEHAVIORAL_HEALTH_RN,
    label: 'Behavioral Health RN',
  },
  {
    value: EntityRole.SPECIALIZATION__ADVANCED_SOCIAL_NEEDS_CP,
    label: 'Advanced Social Needs CP',
  },
  {
    value: EntityRole.SPECIALIZATION__ADVANCED_SOCIAL_NEEDS_SW,
    label: 'Advanced Social Needs SW',
  },
  {
    value: EntityRole.SPECIALIZATION__ADVANCED_SOCIAL_NEEDS_RN,
    label: 'Advanced Social Needs RN',
  },
  {
    value: EntityRole.SPECIALIZATION__SITE_OF_SERVICE_SHIFT_RN,
    label: 'Site of Service RN',
  },
  {
    value: EntityRole.SPECIALIZATION__PALLIATIVE_CARE_NP,
    label: 'Palliative Care NP',
  },
  {
    value: EntityRole.SPECIALIZATION__TRANSITIONS_OF_CARE_AA,
    label: 'Transitions of Care AA',
  },
  {
    value: EntityRole.SPECIALIZATION__TRANSITIONS_OF_CARE_CP,
    label: 'Transitions of Care CP',
  },
  {
    value: EntityRole.SPECIALIZATION__TCM_COB_RN,
    label: 'TCM COB RN',
  },
  {
    value: EntityRole.SPECIALIZATION__TRIAGE_NP,
    label: 'Triage Nurse Practitioner',
  },
  {
    value: EntityRole.SPECIALIZATION__TRIAGE_SW,
    label: 'Triage Social Worker',
  },
  {
    value: EntityRole.SPECIALIZATION__TRIAGE_CP,
    label: 'Triage Care Partner',
  },
  {
    value: EntityRole.SPECIALIZATION__HWV_NP,
    label: 'HWV Nurse Practitioner',
  },
  {
    value: EntityRole.SPECIALIZATION__COMMUNITY_CP,
    label: 'Community Care Partner',
  },
  {
    value: EntityRole.SPECIALIZATION__PRACTICE_COORDINATOR_TEAM_LEAD,
    label: 'Practice Coordinator Team Lead',
  },
  {
    value: EntityRole.NURSE_PRACTITIONER_TEAM_LEAD,
    label: 'Nurse Practitioner Team Lead',
  },
  {
    value: EntityRole.SPECIALIZATION__MEDICAL_DIRECTOR_PALLIATIVE_CARE,
    label: 'Medical Director - Palliative Care',
  },
  {
    value: EntityRole.SPECIALIZATION__MEDICAL_DIRECTOR_ONCOLOGY,
    label: 'Medical Director - Oncology',
  },
  {
    value: EntityRole.PRACTICE_COORDINATOR,
    label: 'Practice Coordinator',
  },
  {
    value: EntityRole.PRACTICE_ADMINISTRATOR,
    label: 'Practice Administrator',
  },
  {
    value: EntityRole.SPECIALIZATION__MAILER_AA,
    label: 'Mailer AA',
  },
  {
    value: EntityRole.ENROLLMENT_OPS_COORDINATOR,
    label: 'Enrollment Ops Coordinator',
  },
  {
    value: EntityRole.AUTOMATION,
    label: 'Automation',
  },
]

export const additionalAssignableRoleValues = additionalAssignableRoles.map(
  (obj) => obj.value
)
